var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnInspectionWhite = function SvgIcnInspectionWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1988_29419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54003 2.53979C1.95678 2.12304 2.52201 1.88892 3.11138 1.88892H4.66694C5.03513 1.88892 5.3336 2.18739 5.3336 2.55558C5.3336 2.92377 5.03513 3.22225 4.66694 3.22225H3.11138C2.87563 3.22225 2.64954 3.3159 2.48284 3.4826C2.31614 3.6493 2.22249 3.87539 2.22249 4.11114V13.4445C2.22249 13.6802 2.31614 13.9063 2.48284 14.073C2.64954 14.2397 2.87563 14.3334 3.11138 14.3334H10.8892C11.1249 14.3334 11.351 14.2397 11.5177 14.073C11.6844 13.9063 11.778 13.6802 11.778 13.4445V4.11114C11.778 3.87539 11.6844 3.6493 11.5177 3.4826C11.351 3.3159 11.1249 3.22225 10.8892 3.22225H9.3336C8.96542 3.22225 8.66694 2.92377 8.66694 2.55558C8.66694 2.18739 8.96542 1.88892 9.3336 1.88892H10.8892C11.4785 1.88892 12.0438 2.12304 12.4605 2.53979C12.8773 2.95654 13.1114 3.52177 13.1114 4.11114V13.4445C13.1114 14.0338 12.8773 14.5991 12.4605 15.0158C12.0438 15.4326 11.4785 15.6667 10.8892 15.6667H3.11138C2.52201 15.6667 1.95678 15.4326 1.54003 15.0158C1.12329 14.5991 0.88916 14.0338 0.88916 13.4445V4.11114C0.88916 3.52177 1.12329 2.95654 1.54003 2.53979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22222 1.66671C5.98647 1.66671 5.76038 1.76036 5.59368 1.92706C5.42698 2.09376 5.33333 2.31985 5.33333 2.5556C5.33333 2.79134 5.42698 3.01744 5.59368 3.18414C5.76038 3.35083 5.98647 3.44449 6.22222 3.44449H7.77778C8.01353 3.44449 8.23962 3.35083 8.40632 3.18414C8.57302 3.01744 8.66667 2.79134 8.66667 2.5556C8.66667 2.31985 8.57302 2.09376 8.40632 1.92706C8.23962 1.76036 8.01353 1.66671 7.77778 1.66671H6.22222ZM4.65087 0.984248C5.06762 0.5675 5.63285 0.333374 6.22222 0.333374H7.77778C8.36715 0.333374 8.93238 0.5675 9.34913 0.984248C9.76587 1.401 10 1.96623 10 2.5556C10 3.14497 9.76587 3.7102 9.34913 4.12694C8.93238 4.54369 8.36715 4.77782 7.77778 4.77782H6.22222C5.63285 4.77782 5.06762 4.54369 4.65087 4.12694C4.23413 3.7102 4 3.14497 4 2.5556C4 1.96623 4.23413 1.401 4.65087 0.984248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80474 7.52864C10.0651 7.78899 10.0651 8.2111 9.80474 8.47145L6.69363 11.5826C6.43328 11.8429 6.01117 11.8429 5.75082 11.5826L4.19526 10.027C3.93491 9.76665 3.93491 9.34454 4.19526 9.08419C4.45561 8.82384 4.87772 8.82384 5.13807 9.08419L6.22222 10.1683L8.86193 7.52864C9.12228 7.26829 9.54439 7.26829 9.80474 7.52864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1988_29419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 16,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnInspectionWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_inspection_white.6e2a38d5.svg";
export { ForwardRef as ReactComponent };